import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {PromotionCampaignDetailModel} from '../../../../../../models/promotion-campaign.model';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PromotionMessageService} from '../../../../../../services/promotion/promotion-message.service';
import {CalendarTranslateService} from '../../../../../../modules/UIKit/services/calendarTranslate.service';
import {CalendarTranslate} from '../../../../../../models/calendarTranslate.model';

@Component({
  selector: 'kv-promo-tab-detail-form',
  template: `
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-angle-left"
                  iconPos="left" label="{{ 'promotion.backToDetail' | translate }}"
                  (click)="locationBack()">
                </button>
              </div>
            </div>
          </div>
          <form (ngSubmit)="save()" [formGroup]="formData">
            <div class="ui-g form-group">
              <div [kv-form-element]="{ label: 'customerInfoSheet.startDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="start_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'customerInfoSheet.endDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="end_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'promotion.startRedemDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="start_redem_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'promotion.endRedemDate', md: '3'}">
                <p-calendar
                  class="over"
                  [showIcon]="true"
                  formControlName="end_redem_date"
                  [dateFormat]="calendarTranslate.dateFormat">
                </p-calendar>
              </div>
              <div [kv-form-element]="{ label: 'promotion.description', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="description"/>
              </div>
              <div [kv-form-element]="{ label: 'promotion.messages', md: '3' }">
                <p-dropdown
                  [options]="messages"
                  formControlName="message_id">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: '', md: '1' }" style="padding-top: 30px; text-align: -webkit-center;">
                <td class="btn-list">
                  <p-button [disabled]="formData.controls['message_id'].disabled" pTooltip="{{ 'common.edit' | translate }}" icon="fa fas fa-edit" styleClass="ui-button-info" (onClick)="createNewMessage()"></p-button>
                </td>
              </div>
              <div [kv-form-element]="{ label: 'promotion.divisions', md: '4' }">
                <p-multiSelect
                  class="multiselect-container"
                  [options]="divisionSaleNetworkItems"
                  formControlName="dsnList"
                  [filter]="true"
                  scrollHeight="350px"
                  maxSelectedLabels="1"
                  styleClass="multiselect-fixed-height">
                </p-multiSelect>
              </div>
              <div class="ui-g-12 text-right">
                <button
                  pButton
                  type="submit"
                  class="k-generic-btn"
                  icon="fa fa-floppy-o"
                  iconPos="left"
                  label="{{ 'common.saveAndBackToList' | translate }}"
                  [disabled]="formData.controls['start_date'].value > formData.controls['end_date'].value ||
                  formData.controls['start_redem_date'].value > formData.controls['end_redem_date'].value ||
                  formData.controls['start_date'].value === null ||
                  formData.controls['end_date'].value === null ||
                  formData.controls['start_redem_date'].value === null ||
                  formData.controls['end_redem_date'].value === null ||
                  formData.controls['message_id'].value === null ||
                  formData.controls['dsnList'].value === null ||
                  formData.controls['dsnList'].value.length <= 0">
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  `,
  providers: [
    CalendarTranslateService
  ],
  styleUrls: ['./tab-detail-form.component.css']
})
export class TabDetailFormComponent implements OnInit, OnChanges {

  @Input() titlePage;
  @Input() addEditDetail;
  @Input() addEditCampaign;
  @Input() configs;
  @Input() divisionSaleNetworkItems;
  @Input() messages;

  @Output() backToKontable = new EventEmitter();
  @Output() saveDetail = new EventEmitter();
  @Output() showNewMessage = new EventEmitter();

  formData: FormGroup;
  calendarTranslate: CalendarTranslate;

  constructor(private fb: FormBuilder,
              private svcMessage: PromotionMessageService,
              private srvCalendarTranslate: CalendarTranslateService) {
    this.srvCalendarTranslate.pCalendar.subscribe(c => {
      this.calendarTranslate = c
    });
  }

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['addEditDetail'] && changes['addEditDetail'].currentValue === null) {
      this.createForm()
    } else if (changes['addEditDetail'] && changes['addEditDetail'].currentValue !== null) {
      this.createForm(true, changes['addEditDetail'].currentValue)
    }
  }

  locationBack() {
    this.backToKontable.emit();
  }

  createForm(exist = false, editDetail: PromotionCampaignDetailModel = null) {
    if (!exist) {
      this.formData = this.fb.group({
        'campaign_id': this.addEditCampaign.id,
        'message_id': this.svcMessage.createField('message_id', this.configs),
        'start_date': this.svcMessage.createField('start_date', this.configs, null, false, true),
        'end_date': this.svcMessage.createField('end_date', this.configs, null, false, true),
        'start_redem_date': this.svcMessage.createField('start_redem_date', this.configs, null, false, true),
        'end_redem_date': this.svcMessage.createField('end_redem_date', this.configs, null, false, true),
        'description': this.svcMessage.createField('description', this.configs),
        'dsnList': this.svcMessage.createField('dsnList', this.configs)
      })
    } else {
      this.formData = this.fb.group({
        'campaign_id': this.addEditCampaign.id,
        'message_id': this.svcMessage.createField('message_id', this.configs, editDetail.message_id),
        'start_date': this.svcMessage.createField('start_date', this.configs, editDetail.start_date ? new Date(editDetail.start_date) : editDetail.start_date, false, true),
        'end_date': this.svcMessage.createField('end_date', this.configs, editDetail.end_date ? new Date(editDetail.end_date) : editDetail.end_date, false, true),
        'start_redem_date': this.svcMessage.createField('start_redem_date', this.configs, editDetail.start_redem_date ? new Date(editDetail.start_redem_date) : editDetail.start_redem_date, false, true),
        'end_redem_date': this.svcMessage.createField('end_redem_date', this.configs, editDetail.end_redem_date ? new Date(editDetail.end_redem_date) : editDetail.end_redem_date, false, true),
        'description': this.svcMessage.createField('description', this.configs, editDetail.description),
        'dsnList': this.svcMessage.createField('dsnList', this.configs, editDetail.dsnList)
      })
    }
  }

  save() {
    let saveThisCampaignDetail: PromotionCampaignDetailModel = {
      id: this.addEditDetail !== null ? this.addEditDetail.id : null,
      campaign_id: this.addEditCampaign.id ,
      message_id: this.formData.controls['message_id'].value,
      start_date: this.formData.controls['start_date'].value,
      end_date: this.formData.controls['end_date'].value,
      start_redem_date: this.formData.controls['start_redem_date'].value,
      end_redem_date: this.formData.controls['end_redem_date'].value,
      description: this.formData.controls['description'].value,
      dsnList: this.formData.controls['dsnList'].value
    };
    this.saveDetail.emit(saveThisCampaignDetail);
  }

  createNewMessage() {
    let tempFormValues = {
      id: this.addEditDetail !== null ? this.addEditDetail.id : null,
      campaign_id: this.addEditCampaign.id ,
      message_id: this.formData.controls['message_id'].value,
      start_date: this.formData.controls['start_date'].value,
      end_date: this.formData.controls['end_date'].value,
      start_redem_date: this.formData.controls['start_redem_date'].value,
      end_redem_date: this.formData.controls['end_redem_date'].value,
      description: this.formData.controls['description'].value,
      dsnList: this.formData.controls['dsnList'].value
    };
    this.showNewMessage.emit(tempFormValues);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/promotion/campaign/components/tabs/detail/tab-detail-form.component.ts